import { css } from '@/styled-system/css';

export const dateTimeBlockDayRecipe = css.raw({
  'minBlockSize': '2400',
  'minInlineSize': '99px',
  'paddingBlock': 'loose',
  'paddingInline': 'loose',

  '& > [data-c11n-component="ToggleCard.Body"]': {
    display: 'grid',
    justifyContent: 'center',
    justifyItems: 'center',
  },
});
